import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 450px;
  width: 100%;
  background-color: rgba(0, 0, 139, 0);
  color: #000;
  font-size: 2em;
  padding: 10px;
`;
